export const state = () => ({
  fileForm: false,
  headlineForm: true,
  fileCard: false,
  currentFileId: '',
  items: [],
  isUpdate: false,
})

export const mutations = {
  SET_FILE_FORM(state, data) {
    state.fileForm = data
  },
  SET_HEAD_LINE_FORM(state, data) {
    state.headlineForm = data
  },
  SET_FILE_CARD(state, data) {
    state.fileCard = data
  },
  SET_ITEMS(state, data) {
    state.items = data
  },
  SET_CURRENT_FILE_ID(state, data) {
    state.currentFileId = data
  },
  SET_ISUPDATE(state, data) {
    state.isUpdate = data
  },
}
